import { Model } from "./model";
import { Company } from "./company";
import { Contract } from "./contract";
import { Storage } from "./storage";
import { Tester } from "./tester";

export class Testbed extends Model {

  address?: string;

  identifier?: string;

  company?: Company;

  contracts?: Contract[];

  testers?: Tester[];

  currentContract?: Contract;

  storage?: Storage;

  weseth2?: boolean; 

}
